
/**
 * <auto-generated>
 *     This code was generated by a tool.
 *
 *     Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * </auto-generated>
 */

// @ts-ignore 
import { Field, ImageField, FileField, LinkField, Item } from '@sitecore-content-sdk/nextjs';
// @ts-ignore 
import { ComponentProps } from '../lib/component-props';
// @ts-ignore 
import { Pages as ProjectCWPages } from "./Project.CW.model"
// @ts-ignore 
import { PageSpecific as FeatureCWPageSpecific } from "./Feature.CW.model"
// @ts-ignore 
import { Data as FoundationCWData } from "./Foundation.CW.model"
// @ts-ignore 
import { Project as ProjectCWProject } from "./Project.CW.model"
// @ts-ignore 
import { Sitecore as FoundationCWSitecore } from "./Foundation.CW.model"
// @ts-ignore 
import { MedicalProfFolder as ProjectCWMedicalProfFolder } from "./Project.CW.model"
// @ts-ignore 
import { ContentTypes as ProjectCWContentTypes } from "./Project.CW.model"
// @ts-ignore 
import { Api as FeatureCWApi } from "./Feature.CW.model"

export namespace Pages {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/AZSearch
    */
    export type Azsearch = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/AZSearch as an Item
    */
    export type Azsearch_Item = Omit<Item, 'fields'> & Azsearch

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/AZSearch as a Component
    */
    export type Azsearch_Component = ComponentProps & Azsearch

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/AZSearch
    */
    export type AzsearchJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Blog Landing Page
    */
    export type BlogLandingPage = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Blog Landing Page as an Item
    */
    export type BlogLandingPage_Item = Omit<Item, 'fields'> & BlogLandingPage

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Blog Landing Page as a Component
    */
    export type BlogLandingPage_Component = ComponentProps & BlogLandingPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/Blog Landing Page
    */
    export type BlogLandingPageJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/BlogDetailPage
    */
    export type BlogDetailPage = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.Blog & 
FoundationCWData.BaseTemplateSections.PageSearchSettings &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/BlogDetailPage as an Item
    */
    export type BlogDetailPage_Item = Omit<Item, 'fields'> & BlogDetailPage

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/BlogDetailPage as a Component
    */
    export type BlogDetailPage_Component = ComponentProps & BlogDetailPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/BlogDetailPage
    */
    export type BlogDetailPageJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.BlogJson & 
FoundationCWData.BaseTemplateSections.PageSearchSettingsJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/BlogSearchPage
    */
    export type BlogSearchPage = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/BlogSearchPage as an Item
    */
    export type BlogSearchPage_Item = Omit<Item, 'fields'> & BlogSearchPage

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/BlogSearchPage as a Component
    */
    export type BlogSearchPage_Component = ComponentProps & BlogSearchPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/BlogSearchPage
    */
    export type BlogSearchPageJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Condition or Treatment
    */
    export type ConditionOrTreatment = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.PageTaxonomy & 
FoundationCWData.BaseTemplateSections.PageSearchSettings &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Condition or Treatment as an Item
    */
    export type ConditionOrTreatment_Item = Omit<Item, 'fields'> & ConditionOrTreatment

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Condition or Treatment as a Component
    */
    export type ConditionOrTreatment_Component = ComponentProps & ConditionOrTreatment

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/Condition or Treatment
    */
    export type ConditionOrTreatmentJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.PageTaxonomyJson & 
FoundationCWData.BaseTemplateSections.PageSearchSettingsJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Error Page
    */
    export type ErrorPage = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Error Page as an Item
    */
    export type ErrorPage_Item = Omit<Item, 'fields'> & ErrorPage

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Error Page as a Component
    */
    export type ErrorPage_Component = ComponentProps & ErrorPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/Error Page
    */
    export type ErrorPageJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/EventDetailsPage
    */
    export type EventDetailsPage = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/EventDetailsPage as an Item
    */
    export type EventDetailsPage_Item = Omit<Item, 'fields'> & EventDetailsPage

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/EventDetailsPage as a Component
    */
    export type EventDetailsPage_Component = ComponentProps & EventDetailsPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/EventDetailsPage
    */
    export type EventDetailsPageJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/FindCareLP
    */
    export type FindCareLP = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/FindCareLP as an Item
    */
    export type FindCareLP_Item = Omit<Item, 'fields'> & FindCareLP

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/FindCareLP as a Component
    */
    export type FindCareLP_Component = ComponentProps & FindCareLP

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/FindCareLP
    */
    export type FindCareLPJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/GeneralPageT1
    */
    export type GeneralPageT1 = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/GeneralPageT1 as an Item
    */
    export type GeneralPageT1_Item = Omit<Item, 'fields'> & GeneralPageT1

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/GeneralPageT1 as a Component
    */
    export type GeneralPageT1_Component = ComponentProps & GeneralPageT1

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/GeneralPageT1
    */
    export type GeneralPageT1Json = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/GeneralPageT2
    */
    export type GeneralPageT2 = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/GeneralPageT2 as an Item
    */
    export type GeneralPageT2_Item = Omit<Item, 'fields'> & GeneralPageT2

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/GeneralPageT2 as a Component
    */
    export type GeneralPageT2_Component = ComponentProps & GeneralPageT2

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/GeneralPageT2
    */
    export type GeneralPageT2Json = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/GlobalSearchLandingPage
    */
    export type GlobalSearchLandingPage = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/GlobalSearchLandingPage as an Item
    */
    export type GlobalSearchLandingPage_Item = Omit<Item, 'fields'> & GlobalSearchLandingPage

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/GlobalSearchLandingPage as a Component
    */
    export type GlobalSearchLandingPage_Component = ComponentProps & GlobalSearchLandingPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/GlobalSearchLandingPage
    */
    export type GlobalSearchLandingPageJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }
}
export namespace Project.CW {

    /**
    * Represents the template /sitecore/templates/Project/CW/Headless Site
    */
    export type HeadlessSite =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Headless Site as an Item
    */
    export type HeadlessSite_Item = Omit<Item, 'fields'> & HeadlessSite

    /**
    * Represents the template /sitecore/templates/Project/CW/Headless Site as a Component
    */
    export type HeadlessSite_Component = ComponentProps & HeadlessSite

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Headless Site
    */
    export type HeadlessSiteJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Headless Tenant
    */
    export type HeadlessTenant =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Headless Tenant as an Item
    */
    export type HeadlessTenant_Item = Omit<Item, 'fields'> & HeadlessTenant

    /**
    * Represents the template /sitecore/templates/Project/CW/Headless Tenant as a Component
    */
    export type HeadlessTenant_Component = ComponentProps & HeadlessTenant

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Headless Tenant
    */
    export type HeadlessTenantJson =  {
        

    }
}
export namespace Pages {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/HealthandWellBeing
    */
    export type HealthandWellBeing = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/HealthandWellBeing as an Item
    */
    export type HealthandWellBeing_Item = Omit<Item, 'fields'> & HealthandWellBeing

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/HealthandWellBeing as a Component
    */
    export type HealthandWellBeing_Component = ComponentProps & HealthandWellBeing

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/HealthandWellBeing
    */
    export type HealthandWellBeingJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/HomePage
    */
    export type HomePage = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/HomePage as an Item
    */
    export type HomePage_Item = Omit<Item, 'fields'> & HomePage

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/HomePage as a Component
    */
    export type HomePage_Component = ComponentProps & HomePage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/HomePage
    */
    export type HomePageJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }
}
export namespace Pages.LocationTypes {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/Hospital
    */
    export type Hospital = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.Location & 
FoundationCWData.BaseTemplateSections.PageTaxonomy & 
FoundationCWData.BaseTemplateSections.PageSearchSettings &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/Hospital as an Item
    */
    export type Hospital_Item = Omit<Item, 'fields'> & Hospital

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/Hospital as a Component
    */
    export type Hospital_Component = ComponentProps & Hospital

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/LocationTypes/Hospital
    */
    export type HospitalJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.LocationJson & 
FoundationCWData.BaseTemplateSections.PageTaxonomyJson & 
FoundationCWData.BaseTemplateSections.PageSearchSettingsJson &  {
        

    }
}
export namespace Project.CW {

    /**
    * Represents the template /sitecore/templates/Project/CW/JSS Settings
    */
    export type JssSettings =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/JSS Settings as an Item
    */
    export type JssSettings_Item = Omit<Item, 'fields'> & JssSettings

    /**
    * Represents the template /sitecore/templates/Project/CW/JSS Settings as a Component
    */
    export type JssSettings_Component = ComponentProps & JssSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/JSS Settings
    */
    export type JssSettingsJson =  {
        

    }
}
export namespace Pages.LocationTypes {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/LocationPage
    */
    export type LocationPage = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.Location & 
FoundationCWData.BaseTemplateSections.PageTaxonomy & 
FoundationCWData.BaseTemplateSections.PageSearchSettings &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/LocationPage as an Item
    */
    export type LocationPage_Item = Omit<Item, 'fields'> & LocationPage

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/LocationPage as a Component
    */
    export type LocationPage_Component = ComponentProps & LocationPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/LocationTypes/LocationPage
    */
    export type LocationPageJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.LocationJson & 
FoundationCWData.BaseTemplateSections.PageTaxonomyJson & 
FoundationCWData.BaseTemplateSections.PageSearchSettingsJson &  {
        

    }
}
export namespace Pages {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationSearch
    */
    export type LocationSearch = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationSearch as an Item
    */
    export type LocationSearch_Item = Omit<Item, 'fields'> & LocationSearch

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationSearch as a Component
    */
    export type LocationSearch_Component = ComponentProps & LocationSearch

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/LocationSearch
    */
    export type LocationSearchJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Marketing Landing Page
    */
    export type MarketingLandingPage = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.PageTaxonomy & 
FoundationCWData.BaseTemplateSections.PageSearchSettings &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Marketing Landing Page as an Item
    */
    export type MarketingLandingPage_Item = Omit<Item, 'fields'> & MarketingLandingPage

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Marketing Landing Page as a Component
    */
    export type MarketingLandingPage_Component = ComponentProps & MarketingLandingPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/Marketing Landing Page
    */
    export type MarketingLandingPageJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.PageTaxonomyJson & 
FoundationCWData.BaseTemplateSections.PageSearchSettingsJson &  {
        

    }
}
export namespace MedicalProfFolder {

    /**
    * Represents the template /sitecore/templates/Project/CW/Medical Prof Folder/Medical Prof Resource
    */
    export type MedicalProfResource = FoundationCWData.BaseTemplateSections.MedicalProfResource &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Medical Prof Folder/Medical Prof Resource as an Item
    */
    export type MedicalProfResource_Item = Omit<Item, 'fields'> & MedicalProfResource

    /**
    * Represents the template /sitecore/templates/Project/CW/Medical Prof Folder/Medical Prof Resource as a Component
    */
    export type MedicalProfResource_Component = ComponentProps & MedicalProfResource

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Medical Prof Folder/Medical Prof Resource
    */
    export type MedicalProfResourceJson = FoundationCWData.BaseTemplateSections.MedicalProfResourceJson &  {
        

    }
}
export namespace Pages.LocationTypes {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/MentalHealth
    */
    export type MentalHealth = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.Location & 
FoundationCWData.BaseTemplateSections.PageTaxonomy & 
FoundationCWData.BaseTemplateSections.PageSearchSettings &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/MentalHealth as an Item
    */
    export type MentalHealth_Item = Omit<Item, 'fields'> & MentalHealth

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/MentalHealth as a Component
    */
    export type MentalHealth_Component = ComponentProps & MentalHealth

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/LocationTypes/MentalHealth
    */
    export type MentalHealthJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.LocationJson & 
FoundationCWData.BaseTemplateSections.PageTaxonomyJson & 
FoundationCWData.BaseTemplateSections.PageSearchSettingsJson &  {
        

    }
}
export namespace Pages {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/NewsHubLP
    */
    export type NewsHubLP = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/NewsHubLP as an Item
    */
    export type NewsHubLP_Item = Omit<Item, 'fields'> & NewsHubLP

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/NewsHubLP as a Component
    */
    export type NewsHubLP_Component = ComponentProps & NewsHubLP

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/NewsHubLP
    */
    export type NewsHubLPJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }
}
export namespace Project.CW {

    /**
    * Represents the template /sitecore/templates/Project/CW/Page
    */
    export type Page =  {
        fields?: { 
            /**
            * Represents the Content field (2ec2526b-52e4-469d-83a7-401d7b50ae1b).
            */
            Content?: Field<string>;

            /**
            * Represents the Title field (9c063550-df49-46a3-99c6-f830a981a018).
            */
            Title?: Field<string>;
        }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Page as an Item
    */
    export type Page_Item = Omit<Item, 'fields'> & Page

    /**
    * Represents the template /sitecore/templates/Project/CW/Page as a Component
    */
    export type Page_Component = ComponentProps & Page

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Page
    */
    export type PageJson =  {
        
            /**
            * Represents the Content field (2ec2526b-52e4-469d-83a7-401d7b50ae1b).
            */
            Content?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Title field (9c063550-df49-46a3-99c6-f830a981a018).
            */
            Title?: {
                jsonValue: Field<string>
            };


    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Page Design Folder
    */
    export type PageDesignFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Page Design Folder as an Item
    */
    export type PageDesignFolder_Item = Omit<Item, 'fields'> & PageDesignFolder

    /**
    * Represents the template /sitecore/templates/Project/CW/Page Design Folder as a Component
    */
    export type PageDesignFolder_Component = ComponentProps & PageDesignFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Page Design Folder
    */
    export type PageDesignFolderJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Page Designs
    */
    export type PageDesigns =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Page Designs as an Item
    */
    export type PageDesigns_Item = Omit<Item, 'fields'> & PageDesigns

    /**
    * Represents the template /sitecore/templates/Project/CW/Page Designs as a Component
    */
    export type PageDesigns_Component = ComponentProps & PageDesigns

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Page Designs
    */
    export type PageDesignsJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Partial Design Folder
    */
    export type PartialDesignFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Partial Design Folder as an Item
    */
    export type PartialDesignFolder_Item = Omit<Item, 'fields'> & PartialDesignFolder

    /**
    * Represents the template /sitecore/templates/Project/CW/Partial Design Folder as a Component
    */
    export type PartialDesignFolder_Component = ComponentProps & PartialDesignFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Partial Design Folder
    */
    export type PartialDesignFolderJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Partial Designs
    */
    export type PartialDesigns =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Partial Designs as an Item
    */
    export type PartialDesigns_Item = Omit<Item, 'fields'> & PartialDesigns

    /**
    * Represents the template /sitecore/templates/Project/CW/Partial Designs as a Component
    */
    export type PartialDesigns_Component = ComponentProps & PartialDesigns

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Partial Designs
    */
    export type PartialDesignsJson =  {
        

    }
}
export namespace Pages.LocationTypes {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/PrimaryCare
    */
    export type PrimaryCare = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.Location & 
FoundationCWData.BaseTemplateSections.PageTaxonomy & 
FoundationCWData.BaseTemplateSections.PageSearchSettings &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/PrimaryCare as an Item
    */
    export type PrimaryCare_Item = Omit<Item, 'fields'> & PrimaryCare

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/PrimaryCare as a Component
    */
    export type PrimaryCare_Component = ComponentProps & PrimaryCare

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/LocationTypes/PrimaryCare
    */
    export type PrimaryCareJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.LocationJson & 
FoundationCWData.BaseTemplateSections.PageTaxonomyJson & 
FoundationCWData.BaseTemplateSections.PageSearchSettingsJson &  {
        

    }
}
export namespace Pages {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/ProviderProfile
    */
    export type ProviderProfile = FoundationCWData.BaseTemplateSections.ProviderProfile & 
FoundationCWData.BaseTemplateSections.PageTaxonomy & 
FoundationCWData.BaseTemplateSections.PageSearchSettings & 
FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.RatingsAndReviews &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/ProviderProfile as an Item
    */
    export type ProviderProfile_Item = Omit<Item, 'fields'> & ProviderProfile

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/ProviderProfile as a Component
    */
    export type ProviderProfile_Component = ComponentProps & ProviderProfile

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/ProviderProfile
    */
    export type ProviderProfileJson = FoundationCWData.BaseTemplateSections.ProviderProfileJson & 
FoundationCWData.BaseTemplateSections.PageTaxonomyJson & 
FoundationCWData.BaseTemplateSections.PageSearchSettingsJson & 
FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.RatingsAndReviewsJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/ProviderSearch
    */
    export type ProviderSearch = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/ProviderSearch as an Item
    */
    export type ProviderSearch_Item = Omit<Item, 'fields'> & ProviderSearch

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/ProviderSearch as a Component
    */
    export type ProviderSearch_Component = ComponentProps & ProviderSearch

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/ProviderSearch
    */
    export type ProviderSearchJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Specialty
    */
    export type Specialty = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.SpecialityHeader & 
FoundationCWData.BaseTemplateSections.Specialty & 
FoundationCWData.BaseTemplateSections.PageTaxonomy &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Specialty as an Item
    */
    export type Specialty_Item = Omit<Item, 'fields'> & Specialty

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Specialty as a Component
    */
    export type Specialty_Component = ComponentProps & Specialty

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/Specialty
    */
    export type SpecialtyJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.SpecialityHeaderJson & 
FoundationCWData.BaseTemplateSections.SpecialtyJson & 
FoundationCWData.BaseTemplateSections.PageTaxonomyJson &  {
        

    }
}
export namespace Pages.LocationTypes {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/SpecialtyCare
    */
    export type SpecialtyCare = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.Location & 
FoundationCWData.BaseTemplateSections.PageTaxonomy & 
FoundationCWData.BaseTemplateSections.PageSearchSettings &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/SpecialtyCare as an Item
    */
    export type SpecialtyCare_Item = Omit<Item, 'fields'> & SpecialtyCare

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/SpecialtyCare as a Component
    */
    export type SpecialtyCare_Component = ComponentProps & SpecialtyCare

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/LocationTypes/SpecialtyCare
    */
    export type SpecialtyCareJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.LocationJson & 
FoundationCWData.BaseTemplateSections.PageTaxonomyJson & 
FoundationCWData.BaseTemplateSections.PageSearchSettingsJson &  {
        

    }
}
export namespace Pages.TeachingPages {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Teaching Pages/Teaching Folder
    */
    export type TeachingFolder = FoundationCWData.BaseTemplateSections.BaseFolder &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Teaching Pages/Teaching Folder as an Item
    */
    export type TeachingFolder_Item = Omit<Item, 'fields'> & TeachingFolder

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Teaching Pages/Teaching Folder as a Component
    */
    export type TeachingFolder_Component = ComponentProps & TeachingFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/Teaching Pages/Teaching Folder
    */
    export type TeachingFolderJson = FoundationCWData.BaseTemplateSections.BaseFolderJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Teaching Pages/Teaching Sheets Search
    */
    export type TeachingSheetsSearch = FeatureCWPageSpecific.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Teaching Pages/Teaching Sheets Search as an Item
    */
    export type TeachingSheetsSearch_Item = Omit<Item, 'fields'> & TeachingSheetsSearch

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Teaching Pages/Teaching Sheets Search as a Component
    */
    export type TeachingSheetsSearch_Component = ComponentProps & TeachingSheetsSearch

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/Teaching Pages/Teaching Sheets Search
    */
    export type TeachingSheetsSearchJson = FeatureCWPageSpecific.BasePageJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Teaching Pages/TeachingSheets
    */
    export type TeachingSheets = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.TeachingSheets &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Teaching Pages/TeachingSheets as an Item
    */
    export type TeachingSheets_Item = Omit<Item, 'fields'> & TeachingSheets

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/Teaching Pages/TeachingSheets as a Component
    */
    export type TeachingSheets_Component = ComponentProps & TeachingSheets

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/Teaching Pages/TeachingSheets
    */
    export type TeachingSheetsJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.TeachingSheetsJson &  {
        

    }
}
export namespace Pages.LocationTypes {

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/UrgentCare
    */
    export type UrgentCare = FeatureCWPageSpecific.BasePage & 
FoundationCWData.BaseTemplateSections.Location & 
FoundationCWData.BaseTemplateSections.PageTaxonomy & 
FoundationCWData.BaseTemplateSections.PageSearchSettings &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/UrgentCare as an Item
    */
    export type UrgentCare_Item = Omit<Item, 'fields'> & UrgentCare

    /**
    * Represents the template /sitecore/templates/Project/CW/Pages/LocationTypes/UrgentCare as a Component
    */
    export type UrgentCare_Component = ComponentProps & UrgentCare

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Pages/LocationTypes/UrgentCare
    */
    export type UrgentCareJson = FeatureCWPageSpecific.BasePageJson & 
FoundationCWData.BaseTemplateSections.LocationJson & 
FoundationCWData.BaseTemplateSections.PageTaxonomyJson & 
FoundationCWData.BaseTemplateSections.PageSearchSettingsJson &  {
        

    }
}
export namespace ContentTypes.Api.Xealth {

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Items Folder
    */
    export type XealthItemsFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Items Folder as an Item
    */
    export type XealthItemsFolder_Item = Omit<Item, 'fields'> & XealthItemsFolder

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Items Folder as a Component
    */
    export type XealthItemsFolder_Component = ComponentProps & XealthItemsFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Items Folder
    */
    export type XealthItemsFolderJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Link Folder
    */
    export type XealthLinkFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Link Folder as an Item
    */
    export type XealthLinkFolder_Item = Omit<Item, 'fields'> & XealthLinkFolder

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Link Folder as a Component
    */
    export type XealthLinkFolder_Component = ComponentProps & XealthLinkFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Link Folder
    */
    export type XealthLinkFolderJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Link Item
    */
    export type XealthLinkItem = FeatureCWApi.XealthApiMeta & 
FeatureCWApi.XealthLink &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Link Item as an Item
    */
    export type XealthLinkItem_Item = Omit<Item, 'fields'> & XealthLinkItem

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Link Item as a Component
    */
    export type XealthLinkItem_Component = ComponentProps & XealthLinkItem

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Link Item
    */
    export type XealthLinkItemJson = FeatureCWApi.XealthApiMetaJson & 
FeatureCWApi.XealthLinkJson &  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Wistia Folder
    */
    export type XealthWistiaFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Wistia Folder as an Item
    */
    export type XealthWistiaFolder_Item = Omit<Item, 'fields'> & XealthWistiaFolder

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Wistia Folder as a Component
    */
    export type XealthWistiaFolder_Component = ComponentProps & XealthWistiaFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Wistia Folder
    */
    export type XealthWistiaFolderJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Wistia Item
    */
    export type XealthWistiaItem = FeatureCWApi.XealthWistia & 
FeatureCWApi.XealthApiMeta &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Wistia Item as an Item
    */
    export type XealthWistiaItem_Item = Omit<Item, 'fields'> & XealthWistiaItem

    /**
    * Represents the template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Wistia Item as a Component
    */
    export type XealthWistiaItem_Component = ComponentProps & XealthWistiaItem

    /**
    * Represents the GraphQL template /sitecore/templates/Project/CW/Content Types/API/Xealth/Xealth Wistia Item
    */
    export type XealthWistiaItemJson = FeatureCWApi.XealthWistiaJson & 
FeatureCWApi.XealthApiMetaJson &  {
        

    }
}




/**
 * <auto-generated>
 *     This code was generated by a tool.
 *
 *     Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * </auto-generated>
 */ 

export namespace Pages.Constants {

    export const Azsearch = {
        TemplateId: "c323de1a-2434-468f-9eaf-a591a3691496",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const BlogLandingPage = {
        TemplateId: "54c501e7-a7dc-4ad5-9fad-c9c4f60cbeb0",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const BlogDetailPage = {
        TemplateId: "1f627e91-79f2-4ce5-a18a-bf33972b2072",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "a9438408-5b68-42d0-9503-b395b802df6a", 
            "583de106-c5c8-4791-bd50-df54b259a4ba", 
        ]
    }
    export const BlogSearchPage = {
        TemplateId: "e303647a-bba4-47b7-93a1-5bbca2fd6382",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const ConditionOrTreatment = {
        TemplateId: "59dae910-6e92-4f6b-8ffc-dd8649e894ec",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "5bfac361-d515-4ac1-9520-afd45318dd08", 
            "583de106-c5c8-4791-bd50-df54b259a4ba", 
        ]
    }
    export const ErrorPage = {
        TemplateId: "9e606025-2519-4981-b6fd-e803cf5319e0",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const EventDetailsPage = {
        TemplateId: "32f95a9f-4dc6-4038-8dab-cf679bc1d9ef",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const FindCareLP = {
        TemplateId: "74d0e5b8-4ee3-43f0-9e9e-f9a755d6a420",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const GeneralPageT1 = {
        TemplateId: "b25fc994-9d77-45d2-a643-9911c243ca32",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const GeneralPageT2 = {
        TemplateId: "d2b65608-e58c-4e89-9a58-25fd1474c762",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const GlobalSearchLandingPage = {
        TemplateId: "1b76fc9d-ee74-4a14-a086-13a4743af94c",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
}
export namespace Project.CW.Constants {

    export const HeadlessSite = {
        TemplateId: "ac5c5911-839e-4130-8675-5d77b750cb58",
    
        BaseTemplateIds: [
        ]
    }
    export const HeadlessTenant = {
        TemplateId: "c3ad7833-764b-4de0-b42f-dafcdc6a93ef",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Pages.Constants {

    export const HealthandWellBeing = {
        TemplateId: "fe0cdb1e-3aad-4f4c-9531-f870a77589e0",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const HomePage = {
        TemplateId: "3eb0b90d-a579-4c2c-a944-c83772435afe",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
}
export namespace Pages.LocationTypes.Constants {

    export const Hospital = {
        TemplateId: "7c896918-da7a-462a-b019-c2efee5ca462",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "3d061a35-5a31-4ff4-b61a-786af414f5b4", 
            "2a637c18-c95a-4a4a-9c69-740cd4c258e7", 
            "1dd8418d-cbbb-44b7-a70c-b5be8f3a8a4e", 
            "5bfac361-d515-4ac1-9520-afd45318dd08", 
            "583de106-c5c8-4791-bd50-df54b259a4ba", 
        ]
    }
}
export namespace Project.CW.Constants {

    export const JssSettings = {
        TemplateId: "6d778a82-f230-42f7-9ebb-0c25ebc4a6cc",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Pages.LocationTypes.Constants {

    export const LocationPage = {
        TemplateId: "5e737118-a376-4922-84c8-d2d641302d2d",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "3d061a35-5a31-4ff4-b61a-786af414f5b4", 
            "2a637c18-c95a-4a4a-9c69-740cd4c258e7", 
            "1dd8418d-cbbb-44b7-a70c-b5be8f3a8a4e", 
            "5bfac361-d515-4ac1-9520-afd45318dd08", 
            "583de106-c5c8-4791-bd50-df54b259a4ba", 
        ]
    }
}
export namespace Pages.Constants {

    export const LocationSearch = {
        TemplateId: "f08fe54a-0793-4190-9639-3c6c52cd8ae9",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const MarketingLandingPage = {
        TemplateId: "b4c329f2-5b34-4ca8-a20d-be33e2ae4138",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "5bfac361-d515-4ac1-9520-afd45318dd08", 
            "583de106-c5c8-4791-bd50-df54b259a4ba", 
        ]
    }
}
export namespace MedicalProfFolder.Constants {

    export const MedicalProfResource = {
        TemplateId: "d5a1970f-fc8e-472f-880d-ae7697182f6a",
    
        BaseTemplateIds: [
            "4123b059-bf68-439f-b940-dea91cee0f19", 
        ]
    }
}
export namespace Pages.LocationTypes.Constants {

    export const MentalHealth = {
        TemplateId: "38ed8a97-a75b-4fb8-9542-7c8d0580c99a",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "3d061a35-5a31-4ff4-b61a-786af414f5b4", 
            "2a637c18-c95a-4a4a-9c69-740cd4c258e7", 
            "1dd8418d-cbbb-44b7-a70c-b5be8f3a8a4e", 
            "5bfac361-d515-4ac1-9520-afd45318dd08", 
            "583de106-c5c8-4791-bd50-df54b259a4ba", 
        ]
    }
}
export namespace Pages.Constants {

    export const NewsHubLP = {
        TemplateId: "63972d62-408b-4bea-b1b1-4b9fd2c7867a",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
}
export namespace Project.CW.Constants {

    export const Page = {
        TemplateId: "b936184f-fca2-4acc-b7ed-b9f4e6170b8c",
    
        BaseTemplateIds: [
        ]
    }
    export const PageDesignFolder = {
        TemplateId: "9c75cc3a-b79b-47e2-a801-40c6f7414c6f",
    
        BaseTemplateIds: [
        ]
    }
    export const PageDesigns = {
        TemplateId: "11d22431-f378-4a68-8ee5-ffc1ea5005cf",
    
        BaseTemplateIds: [
        ]
    }
    export const PartialDesignFolder = {
        TemplateId: "e2f40205-f385-4134-a57f-bab1f3850e2f",
    
        BaseTemplateIds: [
        ]
    }
    export const PartialDesigns = {
        TemplateId: "f004e782-2325-407d-aa8f-f3195808f8ac",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace Pages.LocationTypes.Constants {

    export const PrimaryCare = {
        TemplateId: "9bd22512-951a-451a-86b6-44203d1e4801",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "3d061a35-5a31-4ff4-b61a-786af414f5b4", 
            "2a637c18-c95a-4a4a-9c69-740cd4c258e7", 
            "1dd8418d-cbbb-44b7-a70c-b5be8f3a8a4e", 
            "5bfac361-d515-4ac1-9520-afd45318dd08", 
            "583de106-c5c8-4791-bd50-df54b259a4ba", 
        ]
    }
}
export namespace Pages.Constants {

    export const ProviderProfile = {
        TemplateId: "6de30456-2d7d-4d28-bf1b-2b2b8aa42e62",
    
        BaseTemplateIds: [
            "56f2284c-35e8-4d8b-9958-eaa3f5b9385b", 
            "5bfac361-d515-4ac1-9520-afd45318dd08", 
            "583de106-c5c8-4791-bd50-df54b259a4ba", 
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "192248e3-45d5-447f-a803-6aa3b6334525", 
        ]
    }
    export const ProviderSearch = {
        TemplateId: "99fbe534-efef-407d-9dc4-4d8016300cd5",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const Specialty = {
        TemplateId: "1fc43940-e22a-4f0a-8453-1db23934aa03",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "d1a5aa15-c5ed-4abd-b0a3-e95fab89c22b", 
            "4259bc75-02bb-452a-b4ec-c6315e4cb528", 
            "5bfac361-d515-4ac1-9520-afd45318dd08", 
        ]
    }
}
export namespace Pages.LocationTypes.Constants {

    export const SpecialtyCare = {
        TemplateId: "4146a279-e77b-4e44-adc6-57c059d4e80e",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "3d061a35-5a31-4ff4-b61a-786af414f5b4", 
            "2a637c18-c95a-4a4a-9c69-740cd4c258e7", 
            "1dd8418d-cbbb-44b7-a70c-b5be8f3a8a4e", 
            "5bfac361-d515-4ac1-9520-afd45318dd08", 
            "583de106-c5c8-4791-bd50-df54b259a4ba", 
        ]
    }
}
export namespace Pages.TeachingPages.Constants {

    export const TeachingFolder = {
        TemplateId: "dec8a781-9e86-4d2f-9090-9797f157bb32",
    
        BaseTemplateIds: [
            "27cf0723-0158-4bc1-a1b9-b23cce29d0b7", 
        ]
    }
    export const TeachingSheetsSearch = {
        TemplateId: "7c4741c8-339e-4828-aff1-412846760677",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
        ]
    }
    export const TeachingSheets = {
        TemplateId: "503baf9c-c27e-4bc4-9e42-31d3643e4b41",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "1075319e-c3fc-4117-b483-0b28a1adc63b", 
        ]
    }
}
export namespace Pages.LocationTypes.Constants {

    export const UrgentCare = {
        TemplateId: "569b9852-17f9-41a4-b6ec-ac740488c05b",
    
        BaseTemplateIds: [
            "141a2797-6fdb-46bb-891e-751279dbc24b", 
            "7f80a124-55f6-48cb-8cec-eb941f8941c0", 
            "3d061a35-5a31-4ff4-b61a-786af414f5b4", 
            "2a637c18-c95a-4a4a-9c69-740cd4c258e7", 
            "1dd8418d-cbbb-44b7-a70c-b5be8f3a8a4e", 
            "5bfac361-d515-4ac1-9520-afd45318dd08", 
            "583de106-c5c8-4791-bd50-df54b259a4ba", 
        ]
    }
}
export namespace ContentTypes.Api.Xealth.Constants {

    export const XealthItemsFolder = {
        TemplateId: "ec97d910-6e90-43a4-aec3-23747908f0f1",
    
        BaseTemplateIds: [
        ]
    }
    export const XealthLinkFolder = {
        TemplateId: "8cb20cfd-c2b5-425d-b511-5edaac912efb",
    
        BaseTemplateIds: [
        ]
    }
    export const XealthLinkItem = {
        TemplateId: "e3b08a1c-5a92-4de0-9c25-a254f3387c98",
    
        BaseTemplateIds: [
            "aafb96ae-364b-4f54-b278-806351533f5f", 
            "9927b092-b098-490e-80aa-31db88b40f0d", 
        ]
    }
    export const XealthWistiaFolder = {
        TemplateId: "ed24c32f-8524-410a-8ce1-69c1d303cbad",
    
        BaseTemplateIds: [
        ]
    }
    export const XealthWistiaItem = {
        TemplateId: "b0dbcf30-56f9-4b8d-93df-addbdeb007b1",
    
        BaseTemplateIds: [
            "94d5afa6-3f51-4520-bf17-9a192bbc23af", 
            "aafb96ae-364b-4f54-b278-806351533f5f", 
        ]
    }
}    


